
import React, { useState } from 'react'
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import ModalPtpPreguntas from 'src/pages/NewFinCompra/ModalPtpPreguntas';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { Layout } from '../styleds';
import { urlFormaPago } from 'src/services/urls';
import useLoading from 'src/hooks/useLoading';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import { POST, guardarLead } from 'src/services';
import { urlEnviarCorreoClientePago } from 'src/services/urls';
import { URL_RETORNO } from 'src/parametros';
import franquicias from 'src/assets/img/franquicias.png'
let err = ""

const PlaceToPay = () => {

  // const {setLoading, resetLoading} = useLoading();

  const { idCotizacion, cotizacion } = useCotizacion();

  const { setLoading, resetLoading, valdiarTerminos } = usePaginaPago();
  const [loadingState, setloadingState] = useState({ loading: false, principal: '', secundario: '' })
  const { getUrl } = usePtp();
  const [url, seturl] = useState('')
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const [opentooltip, setopentooltip] = useState(false)

  const pagarPtp = async () => {

    setloadingState({ loading: true, principal: 'Obteniendo Url', secundario: '' })
    const Data = {
      idCotizacion: idCotizacion,
      forma: 'PTP',
      empCodigo: cotizacion?.empAplica
    };

    const res1 = await POST(urlFormaPago, Data);
    if (!res1.transaccion && res1.error) {
      addWarningToast(
        'Ha ocurrido un problema al seleccionar la forma de pago , por favor intente nuevamente.',
      );
      setloadingState({ loading: false, principal: '', secundario: '' })
      return
    }

    guardarLead(idCotizacion, `PAGINA_PAGO__SELECCIONO_P2P`);

    const res = await getUrl();
    const { hasError } = res
    console.log('response', res)
    if (hasError) {
      // resetLoading();
      addWarningToast(typeof hasError == "string" ? hasError : 'HA OCURRIDO UN PROBLEMA AL REDIRECCIONAR A PLACE TO PAY');
      setloadingState({ loading: false, principal: '', secundario: '' })
      return;
    } else {
      seturl(res.url)
      setloadingState({ loading: false, principal: '', secundario: '' })
      const DataEnviarCorreoCliente = {
        idCotizacion: idCotizacion,
        urlRedirect: `${URL_RETORNO}place-to-pay/${idCotizacion}`,
        empCodigo: cotizacion?.producto?.empCodigo,
      };
      const resp = await POST(urlEnviarCorreoClientePago, DataEnviarCorreoCliente);
      if (resp.transaccion) addSuccessToast(resp.errorDescripcion || 'Se ha enviado un correo al cliente con los datos de pago')
    }
  };

  const handleCopiarUrl = async () => {
    await navigator.clipboard.writeText(url)
    setopentooltip(true)
    setTimeout(() => {
      setopentooltip(false)
    }
      , 2000);

  }
  console.log("url", url);
  return (

    <LoadingWrapper {...loadingState}>
      <div className="row justify-content-center flex-column col-md-7 pt-4">
        <Layout onClick={valdiarTerminos(pagarPtp)}>
          <img
            className="logo"
            style={{ width: 100 }}
            src="https://static.placetopay.com/placetopay-logo.svg"
            alt="Copiar link PLACE TO PAY"
          />
          Generar link de pago
        </Layout>
        <div className="text-center" >
          <img className="img-fluid" src={franquicias} alt="img-franquicias" style={{ maxHeight: 40 }} />
        </div>
      </div>
      {url && <div className="row justify-content-center flex-column col-10 col-md-7 pb-4"  >
        <div className="bd-clipboard  " >

          <button className="btn-clipboard" onClick={() => handleCopiarUrl()}>
            <Tooltip title="Link Copiado" active={opentooltip} />Copiar</button>
        </div>
        <div className="col-12" style={{}} >
          <div className={'highlight'}>
            <pre>
              <code className='language-html' data-lang='html' >
                <span className="nt">{url}</span>
              </code>
            </pre>
          </div>
        </div>
      </div>}
    </LoadingWrapper>
  );
};

export default PlaceToPay;


const Tooltip = ({ title, active }) => {
  if (!active) return <></>
  return (
    <div className="mi-toottip tooltip fade show bs-tooltip-top" role='tooltip' style={{}} >
      <div className='titulo'> {title}</div>
    </div>
  )
}